// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 5605) return "static/chunks/5605-70d753d736c9a0b2.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 5212 ? "ca729f44" : chunkId) + "." + {"3134":"2fda6f6690a84361","5212":"a3f88656813c2717"}[chunkId] + ".js";
};